// extracted by mini-css-extract-plugin
module.exports = {"accordion":"FAQ_accordion__38EPT","box":"FAQ_box__3PSqR","btn":"FAQ_btn__3ezXK","card":"FAQ_card__fFWx8"};